import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-ellipsis-page-ui',
    templateUrl: './bb-ellipsis-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbEllipsisPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
